const research = new URL('../assets/graphic-cards/graphic01.png', import.meta.url);
const design = new URL('../assets/graphic-cards/graphic02.png', import.meta.url);
const iteration = new URL('../assets/graphic-cards/graphic03.png', import.meta.url);

export const graphicImages = [
    { title: 'Research', image: research },
    { title: 'Design', image: design },
    { title: 'Iteration', image: iteration },
]
